import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { UserService } from "./entity-usuarios.service";
import { entityUserLoadFailure, entityUserLoadRequest, entityUserLoadSuccess } from "./entity-usuarios.actions";
import { catchError, map, mergeMap } from "rxjs/operators";
import { of } from "rxjs";

@Injectable()
export class UserEffects {
  constructor(
    private actions$: Actions,
    private userService: UserService,
  ) { }

  loadRequestUser = createEffect(() =>
    this.actions$.pipe(
      ofType(entityUserLoadRequest),
      mergeMap(() =>
        this.userService.getAll().pipe(
          map((items) => entityUserLoadSuccess({ items })),
          catchError((error) => of(entityUserLoadFailure({ error })))
        )
      )
    ))

  loadRequestUserSuccess = createEffect(() =>
    this.actions$.pipe(
      ofType(entityUserLoadSuccess),
    ), { dispatch: false })
}
